import { render, staticRenderFns } from "./ActivityFeeds.vue?vue&type=template&id=65ce6c10"
import script from "./ActivityFeeds.vue?vue&type=script&lang=js"
export * from "./ActivityFeeds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports